<template>
  <div class="main">
    <router-view/>
  </div>

</template>

<style lang="scss" scoped>
.main{
  width: 100vw;
  min-height: 100vh;
  height: auto;
  background-color: #42b983;
}

</style>
